var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 339,
    height: 120,
    viewBox: "0 0 339 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 120.581,
    height: 13.74,
    transform: "translate(0 0)",
    fill: "#117446"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(-359 -935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 339,
    height: 120,
    rx: 40,
    transform: "translate(359 935)",
    fill: "#cdfae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(536.519 1014)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M0,10.133,7.853,2.607A9.353,9.353,0,0,1,19.979,1.9l.041-.046.75.709L27.9,9.394a6.944,6.944,0,0,0,9.631,0l7.837-7.512.045.046a9.371,9.371,0,0,1,11.372,0l.04-.041.712.673,7.13,6.834a6.943,6.943,0,0,0,9.63,0l7.837-7.512.046.046a9.369,9.369,0,0,1,11.371,0l.041-.041.711.673,7.13,6.834a6.944,6.944,0,0,0,9.631,0l7.851-7.526L120.581,3.6l-7.853,7.526a9.341,9.341,0,0,1-12.165.68l-.04.04-.712-.673-7.13-6.833a6.944,6.944,0,0,0-9.631,0l-7.837,7.511-.045-.045a9.337,9.337,0,0,1-11.372,0l-.04.04-.712-.673L55.915,4.342a6.945,6.945,0,0,0-9.632,0l-7.836,7.511-.046-.045a9.335,9.335,0,0,1-11.371,0l-.041.04-.711-.673-7.13-6.833a6.944,6.944,0,0,0-9.631,0L1.666,11.866",
    fill: "#117446"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_4213440_community_group_leader_people_team_icon",
    "data-name": "4213440_community_group_leader_people_team_icon",
    transform: "translate(399.4 998.1)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M48.23,42a8.23,8.23,0,1,0,8.23,8.23A8.254,8.254,0,0,0,48.23,42Zm0,13.716a5.487,5.487,0,1,1,5.487-5.487A5.5,5.5,0,0,1,48.23,55.716Z",
    transform: "translate(-25.889 -27.006)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M36.336,100.8a18.527,18.527,0,0,0-13.511,5.864l-.926.994,1.989,1.886.926-.994a15.761,15.761,0,0,1,23.043,0l.926.994,1.989-1.886-.926-.994A18.66,18.66,0,0,0,36.336,100.8Z",
    transform: "translate(-13.996 -65.643)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M97,47.9v2.743a11.472,11.472,0,0,1,8.436,3.669l1.989-1.886A14.269,14.269,0,0,0,97,47.9Z",
    transform: "translate(-63.344 -30.883)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M91,7.45A6.55,6.55,0,1,0,84.45,14,6.571,6.571,0,0,0,91,7.45Zm-10.356,0a3.806,3.806,0,1,1,3.806,3.806A3.82,3.82,0,0,1,80.643,7.45Z",
    transform: "translate(-50.793 0)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M11.024,47.9A14.269,14.269,0,0,0,.6,52.426l1.989,1.886a11.417,11.417,0,0,1,8.436-3.669Z",
    transform: "translate(0 -30.883)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M25,7.45A6.55,6.55,0,1,0,18.45,14,6.571,6.571,0,0,0,25,7.45Zm-6.55,3.806A3.806,3.806,0,1,1,22.256,7.45,3.82,3.82,0,0,1,18.45,11.256Z",
    transform: "translate(-7.425 0)",
    fill: "#117446"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(9 -6)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(464 1024)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(478 1024)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(492 1024)",
    fill: "#117446"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.70fee1ff4e2d019300645d88bda6ffca.svg";
export { ForwardRef as ReactComponent };